import React from 'react';
import StrategicRoadmapComp from './StrategicRoadmapComp';

function StrategicRoadmap() {
  return <StrategicRoadmapComp />;
}

export default StrategicRoadmap;
